module.exports = __webpack_public_path__ + "img/videosdk-item-5.e8bd066.png";